import { defineCustomElement } from '@tyler-components-web/core';
import { FooterItemComponent } from './footer-item';
export * from './footer-item-constants';
export * from './footer-item';
export function defineFooterItemComponent() {
    defineCustomElement(FooterItemComponent);
}
